import BaseAPI from '../base'

function getRegion(code) {
    return BaseAPI.get(`worldwide/region/${code}`);
}

export default {
    getRegion
}